import React from "react";
import { utils, writeFile } from "xlsx-js-style";
import CustomInput from "../components/formik/CustomInput";
import {
  ServiceBackground,
  ServiceConact,
} from "../components/reports/ServiceColumn";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import {
  getCurrentFortnightName,
  getOrderType,
  getReason,
} from "../models/ReportOperatorSalary";
import CustomSelect from "../components/formik/CustomSelect";

const OrdersPaymentsForm = ({
  formik,
  records,
  status,
  paymentTypes,
  payments,
  vehicleTypes
}) => {
  const exportToExcel = () => {
    const workbook = utils.book_new();
    const sheetName = "Pagos";
    const headerStyle = { fill: { fgColor: { rgb: "DDEBF7" } } };
    const rowStyle = { fill: { fgColor: { rgb: "53ff00" } } };
    const totalStyle = { fill: { fgColor: { rgb: "FFF2CC" } } };

    const sheetData = [
      [
        { t: "s", v: "Folio orden", s: headerStyle },
        { t: "s", v: "Pago registrado por", s: headerStyle },
        { t: "s", v: "Plataforma", s: headerStyle },
        { t: "s", v: "Tipo de Servicio", s: headerStyle },
        { t: "s", v: "Tipo de Vehículo", s: headerStyle }, 
        { t: "s", v: "Fecha de Pago", s: headerStyle },
        { t: "s", v: "Tipo de Pago", s: headerStyle },
        { t: "s", v: "Monto", s: headerStyle },
      ],
    ];

    let totalAmount = 0;
    const baseUrl = window.location.origin;

    payments.forEach((payment) => {
      const orderId = payment.order_id || payment.orderVial_id;

      const folio =
        payment.Order?.folio ??
        payment.OrderVial?.folio ??
        (orderId ? orderId.toString().padStart(5, "0") : "N/A");

      // Tipo de servicio
      let tipoServicio;
      if (payment.tipo === "Varo Express") {
        tipoServicio =
          payment.OrderVial?.typeService?.type_service_name ?? "N/A";
      } else {
        if (payment.Order?.typeService?.type_service_name) {
          tipoServicio = payment.Order.typeService.type_service_name;
        } else if (payment.Order) {
          tipoServicio = getOrderType(payment.Order);
        } else {
          tipoServicio = "N/A";
        }
      }

      //Tipo de vehículo
      const tipoVehiculo =
        payment.tipo === "Varo Express"
          ? (payment.OrderVial?.vehicles?.map(
              (v) => v.VehicleModel?.VehicleType?.vehicle_type_name
            ).join(", ") || "N/A")
          : (payment.Order?.Vehicles?.map(
              (v) => v.VehicleModel?.VehicleType?.vehicle_type_name
            ).join(", ") || "N/A");

      const tipoPlataforma = payment.tipo ?? "Desconocido";

      const fechaPago = payment.payment_date
        ? format(new Date(payment.payment_date + "T00:00:00"), "dd/MMM/yyyy", { locale: es }).toLowerCase()
        : "N/A";

      const tipoPago = payment?.PaymentType?.payment_type_name || "N/A";

      const monto = Number(payment.payment_amount) || 0;

      const creadoPor = payment.creator_payment
        ? `${payment.creator_payment.name} ${payment.creator_payment.first_surname}`
        : "N/A";

      sheetData.push([
        {
          t: "s",
          v: folio,
          l: {
            Target:
              tipoPlataforma === "Varo Express"
                ? `${baseUrl}/orders-vial/editOrder/${orderId}`
                : `${baseUrl}/orders/edit/${orderId}`,
          },
          s: rowStyle,
        },
        { t: "s", v: creadoPor, s: rowStyle },
        { t: "s", v: tipoPlataforma, s: rowStyle },
        { t: "s", v: tipoServicio, s: rowStyle },
        { t: "s", v: tipoVehiculo, s: rowStyle }, 
        { t: "s", v: fechaPago, s: rowStyle },
        { t: "s", v: tipoPago, s: rowStyle },
        { t: "n", v: monto, s: rowStyle },
      ]);

      totalAmount += monto;
    });

    sheetData.push([{ t: "s", v: "" }]); // Fila vacía

    sheetData.push([
      { t: "s", v: "Total", s: totalStyle },
      { t: "s", v: "", s: totalStyle },
      { t: "s", v: "", s: totalStyle },
      { t: "s", v: "", s: totalStyle },
      { t: "s", v: "", s: totalStyle },
      { t: "s", v: "", s: totalStyle },
      { t: "n", v: totalAmount, s: totalStyle },
    ]);

    const worksheet = utils.aoa_to_sheet(sheetData);
    worksheet["!cols"] = [
      { wch: 15 }, // Folio orden
      { wch: 30 }, // Creado por
      { wch: 20 }, // Plataforma
      { wch: 25 }, // Tipo de Servicio
      { wch: 25 }, // Tipo de Vehículo
      { wch: 20 }, // Fecha
      { wch: 20 }, // Tipo de Pago
      { wch: 15 }, // Monto
    ];

    utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, "Pagos_" + getCurrentFortnightName() + ".xlsx");
  };

  return (
    <React.Fragment>
      <div className="row align-items-end gx-1">
        {/* inputs de rango de fecha de pagos */}
        <CustomInput
          label="Pago desde"
          field="start"
          type="date"
          formik={formik}
          sm={3}
        />
        <CustomInput
          label="Pago hasta"
          field="end"
          type="date"
          formik={formik}
          sm={3}
        />

        {/* <CustomSelect
          label="Estatus orden"
          field="status"
          formik={formik}
          options={status}
          required
          sm={4}
        /> */}

        <CustomSelect
          label="Tipo de pago"
          field="paymentTypes"
          formik={formik}
          options={paymentTypes}
          required
          sm={2}
        />

        {/* <CustomSelect
          label="Plataforma"
          field="companyType"
          formik={formik}
          options={[
            { value: "all", label: "Todas" },
            { value: "Gruas Varo", label: "Gruas Varo" },
            { value: "Varo Express", label: "Varo Express" },
          ]}
          required
          sm={2}
        /> */}
        <CustomSelect
          label="Tipo de vehículo"
          field="vehicleTypeId"
          formik={formik}
          options={vehicleTypes}
          required
          sm={2}
        />


        <div className="col-sm-2 d-flex gap-2">
          <button
            className="btn btn-primary w-50"
            onClick={() => formik.handleSubmit()}
          >
            <i className="fa-solid fa-magnifying-glass" />
            &nbsp;Buscar
          </button>
          <button
            className="btn btn-success w-50"
            onClick={() => exportToExcel()}
          >
            <i className="fa-solid fa-file-excel" />
            &nbsp;Descargar
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrdersPaymentsForm;
